
import React from 'react';
import { Text4, Text5 } from '../../../styles';
import { printRupee } from '../../../app_methods';
import moment from 'moment';
import { Badge, Button, Icon } from 'antd';
import { TALLY_INVOICE_STATUS_TYPES } from '../../../constants';

export const getTallyInvoiceTableColumns = (methods) => [{
        title: "Invoice Number",
        key: "invoice_number",
        render: (record) => <Text4>{record.invoice_number}</Text4>
    }, {
        title: "Vendor Name",
        key: "beneficiary_account_name",
        render: (record) => <Text4>{record.beneficiary_account_name}</Text4>
    },{
        title: "Account Details",
        key: "beneficiary_account_number",
        render: (record) => <div>
            <Text4 className="d-block">{record.beneficiary_account_number}</Text4>
            <Text4 className="d-block" secondary>{record.beneficiary_account_ifsc}</Text4>
            </div>
    },{
        title: "Invoice Date",
        key: "invoice_date",
        render: (record) => <Text4>{moment(record.invoice_date).format("ll")}</Text4>
    }, {
        title: "Due Date",
        key: "due_date",
        render: (record) =><Text4>{moment(record.due_date).format("ll")}</Text4>
    }, {
        title: "Transfer Amount",
        key: "total_amount",
        render: (record) => <Text4>{printRupee(record.total_amount)}</Text4>
    },{
        title: "Status",
        key: "status",
        render: (record) => <Badge color={TALLY_INVOICE_STATUS_TYPES[record.status].color} text={<Text4>{TALLY_INVOICE_STATUS_TYPES[record.status].label}</Text4>} />
    }, {
        title: "Actions",
        render: (record) => <>
            <Button className="mr-1" size="small" onClick={() => methods.toggleTallyInvoiceDetailsDrawer(record)}>Details</Button>
        </>
    }
];


export const tallyInvoiceFilterNodes = ()=> ([{
    label: "Invoice Number",
    field: "invoice_number",
    placeholder: "Enter Invoice Number",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Status",
    field: "status",
    placeholder: "Select Status",
    inputType: "select",
    defaultValue: undefined,
    options: Object.keys(TALLY_INVOICE_STATUS_TYPES).map((type, index) => {
        let object = {};
        object.key = index;
        object.value = type;
        object.label = <Badge color={TALLY_INVOICE_STATUS_TYPES[type].color} text={<Text4>{TALLY_INVOICE_STATUS_TYPES[type].label}</Text4>} />;
        return object;
    })
},{
    label: "Vendor Name",
    field: "beneficiary_account_name",
    placeholder: "Enter Vendor Name",
    inputType: "text",
    defaultValue: ""
},
]);


// export const tallyInvoiceFilterNodes = (current_user) =>{

//     let nodes = [{
//         label: "Invoice Number",
//         field: "invoice_number",
//         placeholder: "Enter Invoice Number",
//         inputType: "text",
//         defaultValue: ""
//     }, {
//         label: "Status",
//         field: "status",
//         placeholder: "Select Status",
//         inputType: "select",
//         defaultValue: undefined,
//         options: Object.keys(TALLY_INVOICE_STATUS_TYPES).map((type, index) => {
//             let object = {};
//             object.key = index;
//             object.value = type;
//             object.label = <Badge color={TALLY_INVOICE_STATUS_TYPES[type].color} text={<Text4>{TALLY_INVOICE_STATUS_TYPES[type].label}</Text4>} />;
//             return object;
//         })
//     }];

//    if (current_user.is_reseller && current_user.esda){
//         nodes.unshift({
//             label: "Merchant",
//             field: "submerchant_id",
//             placeholder: "Merchant ID",
//             width: 250,
//             inputType: "select",
//             showSearch: true,
//             defaultValue: undefined,
//             options: current_user.submerchants ? current_user.submerchants.map((sub_merchant, index) => {
//                 let object = {};
//                 object.key = index;
//                 object.value = sub_merchant.id;
//                 object.label = sub_merchant.name+" ("+sub_merchant.email+")"
//                 return object;
//             }): []

//         })
//     }
//     return nodes
// } 
